module.exports = __webpack_public_path__ + "static/media/enable_cookies.78c2f853.gif";